export enum Permission {
  private = 'private',
  public = 'public',
}

export enum AccountStatus {
  legacyActive = 'legacy_active',
  freeTrialActive = 'free_trial_active',
  freeTrialExpired = 'free_trial_expired',
  paddleActive = 'paddle_active',
  paddleCanceled = 'paddle_cancelled',
  paddleDeleted = 'paddle_deleted',
}
